module.exports = __webpack_public_path__ + "static/media/users.d1d51217.svg";